<template>
  <div class="flex justify-end items-center">
    <div v-if="!isAuthenticated && !isCFSWhitelabel()" class="gap-6 hidden md:flex">
      <router-link to="/get-started">
        <OtivoButton class="w-[187px]" colour="red" data-test="signUpBtn" size="medium">
          {{ buttonText }}
        </OtivoButton>
      </router-link>
      <OtivoButton
        class="w-[187px]"
        colour="transparent"
        data-test="loginBtn"
        size="medium"
        @click="auth0.login">
        Log in
      </OtivoButton>
    </div>
    <div v-else-if="isAuthenticated" class="gap-6 hidden md:flex">
      <ContactAdviserMailLink
        v-if="isAuthenticated && adviserPortalEnabled"
        class="text-blue-2 whitespace-nowrap text-center px-3 py-2"
        data-test="dashboard-header-contactadviser-button" />
      <button
        v-if="feedbackEnabled && whitelabel.identifier === 'OTIVO'"
        class="min-w-20 button-2 text-blue-2 underline hidden lg:block cursor-pointer"
        data-test="header-feedback-button"
        @click="openFeedbackModal">
        Leave feedback
      </button>
      <button
        class="min-w-20 button-2 text-blue-2 underline hidden lg:block cursor-pointer"
        data-test="signOutBtn"
        @click="handleSignOut">
        Sign out
      </button>
    </div>
    <!-- Burger Menu Only for Mobile -->
    <button
      v-if="!isAuthenticated"
      class="xl:hidden mx-[30px] cursor-pointer"
      data-test="sideBarBtn"
      @click="toggleSideBar">
      <svg
        fill="none"
        height="18"
        viewBox="0 0 30 18"
        width="30"
        xmlns="http://www.w3.org/2000/svg">
        <line stroke="white" stroke-width="2" x2="30" y1="1" y2="1" />
        <line stroke="white" stroke-width="2" x2="30" y1="9" y2="9" />
        <line stroke="white" stroke-width="2" x2="30" y1="17" y2="17" />
      </svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from 'vuex'
import OtivoButton from '@/components/OtivoButton.vue'
import { isAuthenticated, useAuth0 } from '@/lib/AuthenticatorPlugin.ts'
import { useModalStore } from '@/store/pinia/ModalStore.ts'
import ConfirmationModal from '@/components/Modals/ConfirmationModal.vue'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { useCheckUser } from '@/composables/users/checkUser.ts'
import { isCFSWhitelabel } from '@/composables/isCFSWhitelabel.ts'
import { computed } from 'vue'

import { FeatureList, useLDFlag } from '@/lib/ldClient.ts'
import FeedbackFormModal from '@/components/BrandComponents/Otivo/Feedback/FeedbackFormModal.vue'
import ContactAdviserMailLink from '@/app/components/public/advisers/ContactAdviserMailLink.vue'

const store = useStore()
const auth0 = useAuth0()
const sessionStore = useSessionStore()
const { isAdmin } = useCheckUser()

// note this flag is not setup in launchdarkly yet, but it will be used to control the visibility of the feedback button
const feedbackEnabled = useLDFlag(FeatureList.ENABLE_CUSTOMER_FEEDBACK, false)
const adviserPortalEnabled = useLDFlag(FeatureList.ENABLE_ADVISER_HOMEPAGE, false)

const toggleSideBar = () => {
  store.dispatch('toggleSideBar')
}

const whitelabel = sessionStore.getWhitelabelData
const buttonText = computed(() => {
  return whitelabel.id === 1 ? 'Start free trial' : 'Get started'
})

const modalStore = useModalStore()
const handleSignOut = () => {
  modalStore.openModal(
    ConfirmationModal,
    {
      heading: 'Sign out',
      body: "Are you sure you're ready to logout?",
      confirmFunction: signOut,
    },
    'large',
    false,
    'background: white;'
  )
}
const openFeedbackModal = () => {
  modalStore.openModal(
    FeedbackFormModal,
    {
      heading: 'Leave feedback',
    },
    'large',
    false,
    'background: white;'
  )
}

const signOut = () => {
  let url = window.location.origin
  url = isAdmin() ? `${url}/admin` : `${url}/`
  sessionStore.logout(url)
}
</script>

<style scoped></style>
